var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-input-container"},[_c('div',{staticClass:"form-title"},[_c('label',{attrs:{"for":"id"}},[_vm._v(_vm._s(_vm.translate(_vm.label))+" "),(_vm.required)?_c('span',{staticClass:"required"},[_vm._v("*")]):_vm._e()])]),_c('input',{staticClass:"form-input",attrs:{"disabled":_vm.disabled},on:{"input":function($event){_vm.$emit('input', $event.target.value)}}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d62f7bd","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form/File.vue
// module id = null
// module chunks = 